// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { GeneralInformation } from '../GeneralInformation/GeneralInformation'
import AccountSettingsEditMode from '../AccountSettingsEditMode/AccountSettingsEditMode'

export const AccountSection = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isEditMode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toggleIsEditMode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setNewActiveTab,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  newActiveTab,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsChangedData,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setSaveChangesFromPopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  saveChangesFromPopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsConfirmationPopUpOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isChangedData,
}) => {
  if (isEditMode) {
    return (
      <AccountSettingsEditMode
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        setNewActiveTab={setNewActiveTab}
        newActiveTab={newActiveTab}
        setIsChangedData={setIsChangedData}
        isChangedData={isChangedData}
        setSaveChangesFromPopUp={setSaveChangesFromPopUp}
        saveChangesFromPopUp={saveChangesFromPopUp}
        setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
        toggleIsEditMode={toggleIsEditMode}
      />
    )
  }

  return <GeneralInformation toggleIsEditMode={toggleIsEditMode} />
}
